import React from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs } from "antd";
import Container from "../../components/Container/Container";
import InformationWrapper from "../../components/Information/InformationWrapper";
import PageHeader from "../../components/utility/pageHeader";
import { useAuth } from "../../contexts/auth";
import Financial from "./Financial/Financial";
import Team from "./Team/Team";

export default function MyAccount() {
  const { tab } = useParams();

  const { HasPermission } = useAuth();

  const navigate = useNavigate();

  const { user } = useAuth();

  const items = [
    {
      key: "personal",
      label: <IntlMessages id="page.myAccount.tabs.information.title" />,
      children: <InformationWrapper />,
    },
  ];

  if (HasPermission("manage_financials")) {
    items.push({
      key: "financial",
      label: <IntlMessages id="page.myAccount.tabs.financial.title" />,
      children: <Financial />,
    });
  }

  if (HasPermission("list_invites")) {
    items.push({
      key: "team",
      label: <IntlMessages id="page.myAccount.tabs.financial.team" />,
      children: <Team />,
    });
  }

  return (
    <Container>
      <PageHeader>
        <IntlMessages id="page.myAccount.title" />
        <span>
          <IntlMessages id="page.myAccount.registered" />{" "}
          {`${new Date(user.created).getDate()}/${new Date(user.created).getMonth() + 1
            }/${new Date(user.created).getFullYear()}`}{" "}
        </span>
      </PageHeader>
      <div className="py-5 px-7 rounded-xl bg-white border-1 shadow-sm">
        <Tabs activeKey={tab} items={items} onChange={navigate} />
      </div>
    </Container>
  );
}
